import React, { FC } from "react";
import { Grid, InputLabel, TextField } from "@mui/material";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../../../components/common/model/styles";
import CounterField from "./CounterField"; // Import the CounterField component

const FormTextField: FC<FormFieldProps> = (props) => {
  const classes = useStyles();
  const inputRender = (isInGrid: boolean) => {
    if (props.type === "counter") {
      return (
        <CounterField
        disabled={props?.disabled}
          id={props.id}
          value={props.value}
          onChange={props.onChange}
          onBlur={props.onBlur}
          onIncrement={props.onIncrement}
          onDecrement={props.onDecrement}
          placeholder={props.placeholder}
          isRounded={props.isRounded}
          isNonMarginTop={props.isNonMarginTop}
          maxValue={props?.maxValue}
          counterWidth={props?.counterWidth}
          counterHeight={props?.counterHeight}
          counterBox={props?.counterBox}
          counterSign={props?.counterSign}
        />
      );
    }

    return (
      <TextField
        style={{
          marginTop: props?.isNonMarginTop ? "0px" : "",
          padding: "0px",
        }}
        hiddenLabel
        variant="outlined"
        {...{
          ...props,
          InputProps: {
            ...props?.InputProps,
            sx: {
              background: "#fff",
              padding: "0px",

              ...props?.InputProps?.sx,
              ...(props?.isRounded && { borderRadius: "50px" }),
              ...(isInGrid && {
                "& input:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 1000px #fff inset",
                  WebkitTextFillColor: "#000",
                  background: "transparent",
                  height: "0px !important",
                  width: "16px",
                },
              }),
            },
            onBlur: (e: any) => {
              props?.onBlur && props?.onBlur(e);
            },
          },
          inputProps: {
            ...props?.InputProps,
            style: {
              ...props?.inputProps?.style,
              padding: "10px", // Set padding for the input element
              height: "0px",
              width: "16px !important",
              maxWidth: "16px",
            },
          },
        }}
        placeholder={props.placeholder}
        name={props?.id}
        label=""
        margin="normal"
        fullWidth
      />
    );
  };

  return (
    <>
      {props?.label ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ? 1.5 : 5}
            className={classes.labelBox}
            sx={{
              marginTop: props?.isNonMarginTop ? "0px !important" : "",
              background: "transparent",
            }}
          >
            <InputLabel
              sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
              shrink
              htmlFor={props?.id}
            >
              {props?.label}
              {props?.isRequired && (
                <span style={{ color: "red", fontWeight: 500 }}>*</span>
              )}
            </InputLabel>
          </Grid>
          <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 7}
            style={{
              padding: "0px",
              paddingTop: "36px",
              height: "0px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {inputRender(true)}
          </Grid>
        </>
      ) : (
        inputRender(false)
      )}
    </>
  );
};

export default FormTextField;
